
import { getCurrentInstance, ref, toRefs, reactive, watch } from 'vue'
import { models, initMouleServe } from '../servece'


const defaultQuerise = Symbol('default')
// api 请求主体导入
export function useHttp() {

  try {
    const {
      appContext: {
        config: { globalProperties }
      }
    } = getCurrentInstance()

    return {
      $api: globalProperties.$api,
      $post: globalProperties.$post,
      $get: globalProperties.$get
    }
  } catch (e) {
    window.app = {}
    window.app.config = {}
    window.app.config.globalProperties = {}
    const globalProperties = initMouleServe(window.app, models)
    return globalProperties
  }

}

// vue3 hooks 封装api请求 
export function useRequest(useApi, params, options) { // 
  const {
    manual = false,
    repeatCancel = false,
    refreshDeps = null,
    refreshDepsParams = null,
    queryKey = null,
    async = true
  } = options || {}
  const querise = reactive({
    [defaultQuerise]: {
      data: null,
      loading: false,
      cancel: () => null,
      err: undefined
    }
  })

  const serviceFn = async (...args) => {
    const [useApi, params, options, resolve, reject] = args
    const key = (queryKey && typeof queryKey === "function") ? queryKey(...args) : defaultQuerise;
    if (!querise[key]) {
      querise[key] = {};
    }
    if (!queryKey && repeatCancel) {
      querise[key].cancel();
    }
    querise[key].loading = true;

    const { instance, cancel } = typeof useApi === "function" ? useApi(params, options) : (() => {
      const useRequests = useHttp()
      if (typeof useApi === "string" && options && options.method) {
        if (useRequests['$' + options.method]) {
          return useRequests['$' + options.method](...args)
        } else {
          return useRequests['$' + 'get'](...args)
        }
      } else {
        return useRequests['$' + 'get'](...args)
      }
    })()
    querise[key].cancel = cancel;
    instance.then((res) => {
      querise[key].data = res.data;
      querise[key].err = undefined;
      if (options && typeof options.onSuccess === "function") {
        options.onSuccess(res, args);
      }

      if (resolve && typeof resolve === "function") {
        resolve({
          querise,
          ...Object.assign(querise[defaultQuerise], { loading: false })
          //  data:res.data,
          //  err: undefined,
          //  loading: false
        })
      }
    })
      .catch((err) => {
        querise[key].err = err;
        if (options && typeof options.onError === "function") {
          options.onError(err, args);
        }
        if (reject && typeof reject === "function") {
          reject({
            querise,
            ...Object.assign(querise[defaultQuerise], { loading: false })
          })
        }
      })
      .finally(() => {
        querise[key].loading = false;
      });
  };

  const run = serviceFn;
  // 依赖更新
  if (refreshDeps) {
    watch(
      refreshDeps,
      () => {
        run(useApi, ...(refreshDepsParams?.value || []));
      },
      { deep: true }
    );
  }


  if (async) {
    return new Promise((resolve, reject) => {
      return run(useApi, params, options, resolve, reject)
    })
  } else {
    if (!manual) {
      run(useApi, params, options);
    }
    return {
      run,
      querise,
      ...toRefs(querise[defaultQuerise])
    }
  }

}

useRequest.randomRange = function (min, max, charStr) {
  /** 随机生成固定位数或者一定范围内的字符串数字组合
   * @param {Number} min 范围最小值
   * @param {Number} max 范围最大值，当不传递时表示生成指定位数的组合
   * @param {String} charStr指定的字符串中生成组合
   * @returns {String} 返回字符串结果
   *
   * */
  let returnStr = "", range;
  if (typeof min == 'undefined') {
    min = 5
  }
  if (typeof max == 'string') {
    charStr = max
  }
  range = ((max && typeof max == 'number') ? Math.round(Math.random() * (max - min)) + min : min)
  charStr = charStr || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (let i = 0; i < range; i++) {
    let index = Math.round(Math.random() * (charStr.length - 1))
    returnStr += charStr.substring(index, index + 1)
  }
  return returnStr
}